<template>
    <div class="help-floating" v-if="resourceCode !== ''">
        <el-tooltip content="帮助" placement="left" effect="light">
            <el-button type="primary" icon="el-icon-search" circle @click="previewFile"></el-button>
        </el-tooltip>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getResourceFile } from './api';
import config from '@/config/user.env';

export default {
    computed: {
        ...mapGetters(['menus'])
    },
    data() {
        return {
            resourceCode: '',
            pdfUrl: '',
            appid: config.uploadAppId,
            appkey: config.uploadAppKey,
            bucket: config.bucket
        };
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        this.deepMenuIn(childrens, i);
                    }
                }
            }
        },
        deepMenuIn(childrens, i) {
            if (childrens[i].frontUrl === this.$route.fullPath) {
                this.resourceCode = childrens[i].resourceCode;
            } else {
                this.deepMenu(childrens[i]);
            }
        },
        previewFile() {
            getResourceFile(this.resourceCode).then(res => {
                if (res && res.data.list.length > 0) {
                    const url = res.data.list[0].pdfDownloadUrl;
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank';
                    a.click();
                } else {
                    this.$message.warning('暂无可下载文档，请联系管理员维护');
                }
            });
        }
    },
    created() {
        const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
        this.deepMenu(menu);
    },
    watch: {
        $route() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
        }
    }
};
</script>
<style lang='less'>
.help-floating {
    width: 14px;
    position: absolute;
    top: 50%;
    right: 0px;
    // box-shadow: -3px -2px 7px 0px rgba(58, 82, 142, 0.32);
    overflow: hidden;
    z-index: 10;
    transition: width .2s;
    &:hover {
        width: 28px;
    }
    .help-icon {
        color: #ffffff;
        font-size: 12px;
        padding: 5px;
    }
}
</style>